import {
	DeviceState,
	SET_DEVICE_TYPE,
	SET_ORIENTATION,
	SET_PLATFORM,
	DeviceStateActions,
} from './types';

const initialState: DeviceState = {
	deviceType: 'desktop',
	orientation: 'landscape',
	platform: 'kiosk',
};

export function deviceReducer(state = initialState, action: DeviceStateActions): DeviceState {
	switch (action.type) {
		case SET_DEVICE_TYPE:
			return { ...state, deviceType: action.value };
		case SET_ORIENTATION:
			return { ...state, orientation: action.value };
		case SET_PLATFORM:
			return { ...state, platform: action.value };
		default:
			return state;
	}
}
